<template>
    <div dir="rtl" class="edit-plan">
        <el-form
        :model="form"
        :rules="rules"
        label-position="top"
        ref="addSourceForm"
        :disabled="loading"
        v-loading="loading">
        <el-form-item prop="name" :label="$t('name')">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item prop="username" :label="$t('username')">
          <el-input v-model="form.username" />
        </el-form-item>
        <el-form-item prop="media" :label="$t('media')">
          <div v-if="media && media.list">
            <template>
              <el-radio
                v-for="m in media.list"
                :key="m.id.numberStr"
                v-model="form.medium_id"
                :label="m.id.numberStr"
              >
                {{m.label}}
              </el-radio>
            </template>
          </div>
        </el-form-item>
        <el-form-item prop="uri" :label="$t('uri')">
            <el-input v-model="form.uri" />
        </el-form-item>
        <div class="line"></div>
        <el-form-item>
            <el-button
            type="primary" :loading="loading" @click="submitAddSource">
            {{ $t('submit') }}
            </el-button>
        </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    var urlValidation = (rule, value, callback) => {
      /* eslint-disable */
      let urlRegex = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/ig
      if (!urlRegex.test(value)) {
        callback(new Error(`${this.$i18n.t('field_required')}`))
      } else {
        callback()
      }
    }
    return {
      form: {
        name: '',
        username: '',
        medium_id: '',
        uri: '',
      },
      rules: {
        name: [{
          required: true,
          message: this.$i18n.t('field_required')
        }],
        username: [{
          required: true,
          message: this.$i18n.t('field_required')
        }],
        uri: [{
          validator: urlValidation,
          trigger: 'blur'
        }]
      },
      loading: false,
      typeError: '',
      sizeError: '',
      files: []
    }
  },
  computed: {
    ...mapGetters([
      'media'
    ]),
  },
  methods: {
    ...mapActions([
      'handleRequest'
    ]),
    fetchMedia () {
      this.handleRequest({
        name: `media`,
        action: 'getAll',
        mutation: 'SET_MEDIA'
      })
    },
    handleAddSourceOnSuccess () {
      const message = this.$i18n.t('is_successful', {
        operation: this.$i18n.t('add_source')
      })
      this.$message({
        message,
        type: 'success'
      })
    },
    submitAddSource () {
      this.$refs['addSourceForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          // const form = new FormData()
          // form.append('name', this.form.name)
          // form.append('username', this.form.username)
          // form.append('medium_id', this.form.medium_id)
          // form.append('uri', this.form.uri)
          // form.append('id_in_platform', this.form.id_in_platform)
          // form.append('id_in_provider', this.form.id_in_provider)

          const params = {
            name: this.form.name,
            username: this.form.username,
            medium_id: this.form.medium_id,
            uri: this.form.uri
          }

          this.handleRequest({
            name: 'sources/',
            action: 'create',
            data: params
          }).then(this.handleAddSourceOnSuccess)
            .finally(() => {
              this.loading = false
              this.form.file = []
              this.$refs['addSourceForm'].resetFields()
              this.$refs['file'].clearFiles()
            })
        } else {
          return false
        }
      })
    }
  },
  created () {
    this.fetchMedia()
  }
}
</script>

<style lang="scss" scoped>
.source-selector {
    &.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
      padding-inline-start: 20px;
      &::after {
        right: 5px;
      }

    }

    .el-select-dropdown__item {
        height: 60px;
        display: flex;
        align-items: center;
        .source-item {
            display: flex;
            align-items: center;
            direction: rtl;
                height: 4.5rem !important;
            &.avatar {
                width: 2.5rem !important;
                height: 2.5rem !important;
                .medium {
                    right: -2px;
                }
            }
        }
        .info {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            margin-inline-start: 10px;
            span {
                line-height: 1.25rem;
            }
        }
    }

}
</style>
